import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';

const HeroVideo = ({ children }) => {
  const videoRef = useRef(null);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleLoadedData = () => {
      setIsVideoLoaded(true);
    };

    // iOS autoplay workaround
    const playVideo = () => {
      video.play().catch(error => {
        console.log('Autoplay prevented:', error);
      });
    };

    video.addEventListener('loadeddata', handleLoadedData);
    video.addEventListener('canplay', playVideo);

    // Try to play immediately
    playVideo();

    return () => {
      video.removeEventListener('loadeddata', handleLoadedData);
      video.removeEventListener('canplay', playVideo);
    };
  }, []);

  const videoUrl = 'https://customer-assets.emergentagent.com/job_drone-carnival/artifacts/clawrpd9_202601192328%20%281%29.mp4';
  const posterUrl = 'https://images.unsplash.com/photo-1764351618255-d6092b5f3a2a?q=80&w=2000&auto=format&fit=crop';

  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0">
        <video
          ref={videoRef}
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay
          loop
          muted
          playsInline
          poster={posterUrl}
          preload="auto"
          data-testid="hero-video"
        >
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Video Loading State */}
        {!isVideoLoaded && (
          <div className="absolute inset-0 bg-background animate-pulse" />
        )}
      </div>

      {/* Enhanced Dark Overlay - Darker at top */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/60 to-black/85" />

      {/* Additional top darkening for better text visibility */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-transparent h-1/3" />

      {/* Animated Scan Lines */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 240, 255, 0.03) 2px, rgba(0, 240, 255, 0.03) 4px)'
      }} />

      {/* Content */}
      <div className="relative z-10 h-full">
        {children}
      </div>
    </div>
  );
};

export default HeroVideo;
